import { Box, TextField, Button, ClickAwayListener } from "@mui/material";
import {
  DateCalendar,
  LocalizationProvider,
  PickersDay,
  TimePicker,
  StaticTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useEffect, useState } from "react";
import "./DateTimePicker.css";
import dayjs from "dayjs";

const TimeDatePicker = ({
  time,
  startDateReFormat,
  endDateReFormat,
  handleStartDate,
  handleEndDate,
}) => {
  const [open, setOpen] = useState(false);
  const [selecting, setSelecting] = useState("start");
  const [showTimePicker, setShowTimePicker] = useState(false);
  const [tempDate, setTempDate] = useState(null);
  const [timeView, setTimeView] = useState("hours"); // Add this state
  const [isNewSelection, setIsNewSelection] = useState(true);

  const formatDateRange = () => {
    const format = time ? "DD/MM/YYYY HH:mm A" : "DD/MM/YYYY"; // Changed format to include AM/PM

    const isValid = (date) => date && dayjs(date).isValid();
    const startValid = isValid(startDateReFormat);
    const endValid = isValid(endDateReFormat);

    if (startValid && !endValid) {
      return `${dayjs(startDateReFormat).format(format)} - End Date`;
    }

    if (startValid && endValid) {
      return `${dayjs(startDateReFormat).format(format)} - ${dayjs(
        endDateReFormat
      ).format(format)}`;
    }

    return "Date Range";
  };
  const handleDateSelect = (date) => {
    const selectedDate = dayjs(date);

    if (time) {
      setTempDate(selectedDate);
      setShowTimePicker(true);
      return;
    }

    if (selecting === "start") {
      handleStartDate(selectedDate);
      setSelecting("end");
    } else {
      // Validate end date is after start date
      if (dayjs(selectedDate).isBefore(dayjs(startDateReFormat))) {
        return;
      }
      handleEndDate(selectedDate);
      setOpen(false);
      setSelecting("start");
    }
  };

  const handleReset = () => {
    setShowTimePicker(false);
    setTempDate(null);
    handleStartDate(null);
    handleEndDate(null);
    setSelecting("start");
    setTimeView("hours");
    setIsNewSelection(true);
    setOpen(false);
  };
  useEffect(() => {
    console.log("Selecting changed to:", selecting);
  }, [selecting]);

  const [ampmSelected, setAmpmSelected] = useState(false);

  const handleTimeSelect = (dateTime) => {
    if (timeView === "hours") {
      if (dateTime && dateTime.isValid()) {
        // Get clock hour (1–12) for both current and previous
        const prevHour = tempDate ? tempDate.format("h") : null;
        const newHour = dateTime.format("h");

        // Only move to minutes if clock hour has changed
        if (prevHour === null || prevHour !== newHour) {
          setTempDate(dateTime);
          setTimeView("minutes");
        } else {
          // If only AM/PM toggled, update tempDate but stay on hour view
          setTempDate(dateTime);
        }
      }
      return;
    }

    // Finalize with selected time (once in minutes view)
    if (!tempDate) return;

    const combinedDateTime = dayjs(tempDate)
      .hour(dateTime.hour())
      .minute(dateTime.minute());

    if (selecting === "start") {
      handleStartDate(combinedDateTime);
      setSelecting("end");
    } else {
      if (combinedDateTime.isBefore(dayjs(startDateReFormat))) return;
      handleEndDate(combinedDateTime);
      setSelecting("start");
      setOpen(false);
    }

    // Reset state
    setShowTimePicker(false);
    setTempDate(null);
    setTimeView("hours");
  };




  const defaultEndDate = dayjs();
  const defaultStartDate = dayjs().subtract(1, "month");

  useEffect(() => {
    if (!startDateReFormat && !endDateReFormat) {
      handleStartDate(defaultStartDate);
      handleEndDate(defaultEndDate);
    }
  }, []);

  return (
    <>
      <Box sx={{ width: "360px" }}>
        <TextField
          fullWidth
          value={formatDateRange()}
          placeholder="Date Range"
          onClick={() => setOpen(true)}
          InputProps={{
            readOnly: true,
            sx: {
              backgroundColor: "#fff",
              "& .MuiInputBase-input": {
                padding: "8px 12px",
                cursor: "pointer",
              },
            },
          }}
        />
        {open && (
          <ClickAwayListener onClickAway={() => {
            setOpen(false);
            setShowTimePicker(false);
            setSelecting("start");
            setTimeView("hours");
          }}>
            <Box
              sx={{
                position: "absolute",
                zIndex: 1000,
                backgroundColor: "#fff",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                borderRadius: "4px",
                mt: 1,
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box sx={{ p: 2 }}>
                  <Box sx={{ mb: 1, textAlign: "center" }}>
                    {selecting === "start"
                      ? "Select Start Date"
                      : "Select End Date"}
                  </Box>
                  {!showTimePicker ? (
                    <DateCalendar
                      value={
                        selecting === "start"
                          ? startDateReFormat
                            ? dayjs(startDateReFormat)
                            : null
                          : endDateReFormat
                            ? dayjs(endDateReFormat)
                            : null
                      }
                      onChange={handleDateSelect}
                      disableFuture
                      defaultValue={dayjs()}
                      minDate={
                        selecting === "end" ? dayjs(startDateReFormat) : undefined
                      }
                    />
                  ) : (
                    <Box>
                      <StaticTimePicker
                        value={
                          tempDate ||
                          (selecting === "start"
                            ? startDateReFormat
                            : endDateReFormat)
                        }
                        onChange={handleTimeSelect}

                        ampm={true}
                        ampmInClock={true}
                        onViewChange={(newView) => setTimeView(newView)}
                        componentsProps={{
                          actionBar: { actions: [] },
                        }}
                        slots={{
                          digitClock: () => null,
                          toolbar: () => null,
                          actionBar: () => null,
                        }}
                      />
                    </Box>
                  )}
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
                  >
                    <Button
                      onClick={() => {
                        setOpen(false);
                        setShowTimePicker(false);
                        setSelecting("start");
                      }}
                      sx={{ color: "#2196f3" }}
                    >
                      CANCEL
                    </Button>
                    <Button
                      onClick={handleReset}
                      sx={{ color: "#2196f3" }}
                    >
                      RESET
                    </Button>
                  </Box>
                </Box>
              </LocalizationProvider>
            </Box>
          </ClickAwayListener>
        )}
      </Box>
    </>
  );
};

export default TimeDatePicker;
